import { get2byteLength } from '@workspace/utils/text'
import { useI18n } from 'vue-i18n'

import { useLocale } from '~/composables/useLocale'

const MAX_NAME_LENGTH = 15
const MAX_NAME_PRONUNCIATION_LENGTH = 15

export const useOperatorValidator = (
  operatorName: Ref<string>,
  operatorNamePronunciation: Ref<string>
) => {
  const { t } = useI18n()
  const { currentLocale } = useLocale()

  const operatorNameErrorMessage = computed(() => {
    if (operatorName.value.length === 0) {
      return t('fieldが入力されていません。', { field: t('名前') })
    }
    if (get2byteLength(operatorName.value) > MAX_NAME_LENGTH * 2) {
      return t('fieldは全角count文字以下で設定してください。', {
        field: t('名前'),
        count: currentLocale.value === 'ja' ? MAX_NAME_LENGTH : MAX_NAME_LENGTH * 2,
      })
    }
    return ''
  })

  const operatorNamePronunciationErrorMessage = computed(() => {
    if (get2byteLength(operatorNamePronunciation.value) > MAX_NAME_PRONUNCIATION_LENGTH * 2) {
      return t('fieldは全角count文字以下で設定してください。', {
        field: t('読み方'),
        count:
          currentLocale.value === 'ja'
            ? MAX_NAME_PRONUNCIATION_LENGTH
            : MAX_NAME_PRONUNCIATION_LENGTH * 2,
      })
    }
    return ''
  })

  const isValid = computed(() => {
    return !operatorNameErrorMessage.value && !operatorNamePronunciationErrorMessage.value
  })

  return {
    operatorNameErrorMessage,
    operatorNamePronunciationErrorMessage,
    isValid,
  }
}
